import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BareSaveIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 16 16' {...props}>
    <path
      d='M4.001 15.026H12v-5.017H4.001v5.017zm9.02 0h2.003V5.177a1.149 1.149 0 00-.1-.4 1.12 1.12 0 00-.209-.36l-3.287-3.145a.763.763 0 00-.291-.24c-.167-.069-.02-.042-.124-.042v4.99a.996.996 0 01-1.002 1.002H3.995a.995.995 0 01-1.001-1.001V.973H.99v14.053h2.003V9.989a.995.995 0 011.001-1.001h8.024a.995.995 0 011.002 1.001v5.037zm-3.017-9.368v-4.35a.338.338 0 00-.333-.334H7.342a.337.337 0 00-.333.334v4.35a.337.337 0 00.333.334h2.329a.339.339 0 00.333-.334zm5.993-.324v9.665A.994.994 0 0114.996 16H1.002A.996.996 0 010 14.998V1.002A.995.995 0 011.002 0h9.665a2.774 2.774 0 011.709.708l2.916 2.916c.425.472.674 1.075.708 1.709h-.003z'
      className='svgicon__hover-hide'
      fill='currentColor'
    />
    <path
      d='M4.001 15.026h8v-5.017H4v5.017zm9.02 0h2.003V5.177a1.15 1.15 0 00-.1-.4 1.12 1.12 0 00-.209-.36l-3.287-3.145a.763.763 0 00-.291-.24c-.166-.069-.02-.042-.124-.042v4.99a.994.994 0 01-1.002 1.002H3.995a.995.995 0 01-1.001-1.001V.973H.99v14.053h2.003V9.989a.995.995 0 011.001-1.001h8.024a.996.996 0 011.002 1.001v5.037zm-3.017-9.368v-4.35a.338.338 0 00-.333-.334H7.342a.337.337 0 00-.333.334v4.35a.337.337 0 00.333.334h2.329a.339.339 0 00.333-.334zm5.993-.324v9.665A.996.996 0 0114.996 16H1.002A.996.996 0 010 14.998V1.002A.995.995 0 011.002 0h9.665a2.774 2.774 0 011.709.708l2.916 2.916c.425.472.675 1.075.708 1.709h-.003z'
      className='svgicon__hover-show'
      fill='currentColor'
    />
  </SvgWrapper>
);
export const SaveIcon = memo(BareSaveIcon);
